var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDot = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "20px",
  height: "20px",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12 9.5C13.3807 9.5 14.5 10.6193 14.5 12C14.5 13.3807 13.3807 14.5 12 14.5C10.6193 14.5 9.5 13.3807 9.5 12C9.5 10.6193 10.6193 9.5 12 9.5Z",
  fill: "#00BFFF"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDot);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dot.1928d4a10358f4b385ed33a68077a4a9.svg";